export default __webpack_public_path__ + "static/media/37.7db933de.png";